import { render, staticRenderFns } from "./ReSendQueueEvent.vue?vue&type=template&id=f4a0d6e0&scoped=true&"
import script from "./ReSendQueueEvent.vue?vue&type=script&lang=js&"
export * from "./ReSendQueueEvent.vue?vue&type=script&lang=js&"
import style0 from "./ReSendQueueEvent.vue?vue&type=style&index=0&id=f4a0d6e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a0d6e0",
  null
  
)

export default component.exports